import actions from './actions';
import mutations from './mutations';
import getters from './getters';

//stateBase可用来重置;
export let stateBase = {
  /*显隐控制*/
  queryItemsShow: {

  },
  /*非显隐控制类型的数据*/
  queryData: {
    imgOriginalBase64: '', // 1012上传图片的原始base64
        position: {}, // 1012图片剪切后,左上角坐标,选框宽高;
        imgStyle: {},
        queryMode: 0, // 查询模式,近似商标（图片或者名称）0,申请号1,申请人2
        isCanUploadImg: true,
        imgLocalUrl: '', // 查询图片的file,0201用来本地显示,放入this.updataUrl()并生成可视的图片
        imgFile: { url: '' }, // 存储上传的图片文件,file格式;
        lastImgFile: null, // 存储最近的图片,file格式;
        littlePicUrl: '',
        imgLineUrl: '', // 查询图片的url,0201用来存储峰哥返回的group1/M00/00/1C/hoYCzFpyco6AKxpjAAAysZsrydo415.jpg,用于传给后台;
  },
  /*接口返回*/
  ajaxResponse: {},
  /*其他,如分页*/
  othersItem:{},
  /*暂时放外面*/
  pageNum_:1,
  pageSize_:60,
  /*不可reset的数据*/
  noReset:{},
  queryBtnClickNum:0,//按钮点击次数
};

export default {
  namespaced: true,
  state:JSON.parse(JSON.stringify(stateBase)),
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/query/index.js